import { Form, Input } from "antd";
import React from "react";

/**
 * This component is used to remove a Chrome accessibility warning about when a
 * password form field is present. The warning suggests to include a
 * corresponding username form field. This component provides an invisible
 * username form field that can be used to prevent the warning.
 */
const HiddenUsernameFormItem: React.FC = () => (
  <Form.Item style={{ display: "none" }}>
    <Input autoComplete="username" />
  </Form.Item>
);

export default HiddenUsernameFormItem;
